import { useMemo } from "react";
import { ProjectType } from "../../../clients/graphqlTypes.js";
import { useTranslate } from "@tolgee/react";

const ALL_PROJECT_TYPES: ProjectType[] = [
  "NEW",
  "DIY",
  "RENOVATION",
  "REPAIR",
  "MAINTENANCE",
  "OTHER",
];

export function useProjectTypes() {
  const { t } = useTranslate("ProjectTypes");

  const projectTypeLabels: Record<ProjectType, string> = useMemo(
    () => ({
      REPAIR: t("Repair"),
      RENOVATION: t("Renovation"),
      MAINTENANCE: t("Maintenance"),
      DIY: t("Do it Yourself"),
      NEW: t("New"),
      OTHER: t("Other / Don't know"),
    }),
    [t]
  );

  const projectTypeOptions = useMemo(
    () =>
      ALL_PROJECT_TYPES.map(projectType => ({
        value: projectType,
        label: projectTypeLabels[projectType],
      })),
    [projectTypeLabels]
  );

  return { projectTypeLabels, projectTypeOptions };
}
